import React from 'react';
import { motion } from 'framer-motion';
import { 
  Leaf, 
  ShoppingBag, 
  Globe2, 
  FileCheck, 
  Users, 
  DollarSign,
  Truck,
  Scale
} from 'lucide-react';

 const handleEnrollClick = () => {
    // Replace with your actual enrollment form URL
    window.open('https://paystack.com/pay/femjune2025', '_blank');
  };

const highlights = [
  {
    icon: Leaf,
    title: 'Product Categories',
    description: 'Learn to export various foodstuffs including crops, staples, local delicacies, proteins, and vegetables',
    color: 'bg-green-500'
  },
  {
    icon: ShoppingBag,
    title: 'Market Access',
    description: 'Gain direct access to international buyers and established market channels',
    color: 'bg-blue-500'
  },
  {
    icon: Globe2,
    title: 'Global Standards',
    description: 'Master international food safety and quality standards for export',
    color: 'bg-purple-500'
  },
  {
    icon: FileCheck,
    title: 'Documentation',
    description: 'Complete guide to export documentation and compliance requirements',
    color: 'bg-orange-500'
  },
  {
    icon: Users,
    title: 'Network Building',
    description: 'Connect with successful exporters and industry stakeholders',
    color: 'bg-red-500'
  },
  {
    icon: DollarSign,
    title: 'Pricing Strategy',
    description: 'Learn competitive pricing and profit maximization techniques',
    color: 'bg-teal-500'
  },
  {
    icon: Truck,
    title: 'Logistics Management',
    description: 'Master food transportation and storage best practices',
    color: 'bg-indigo-500'
  },
  {
    icon: Scale,
    title: 'Quality Control',
    description: 'Implement effective quality control measures for food exports',
    color: 'bg-yellow-500'
  }
];

const FEMHighlights = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Program Highlights
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Comprehensive training covering all aspects of foodstuff export business
          </motion.p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {highlights.map((highlight, index) => (
            <motion.div
              key={highlight.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <div className="p-6">
                <div className={`w-12 h-12 ${highlight.color} rounded-lg flex items-center justify-center mb-4`}>
                  <highlight.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {highlight.title}
                </h3>
                <p className="text-gray-600">
                  {highlight.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 bg-green-50 rounded-2xl p-8 text-center"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Start Your Food Export Journey?
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Join our comprehensive masterclass and learn from industry experts with proven success in international food trade.
          </p>
          
          <button onClick={handleEnrollClick} className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors">
            Reserve Your Spot Now
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default FEMHighlights;